module.exports = __webpack_public_path__ + "static/Share-181d58013ffc472bc6eee3140cca9889.svg";